<div class="w-96 space-y-2">
  @if (processingProgressSignal(); as items) {
    @for (item of items; track item.id) {
      <div
        @fadeInOutAnimation
        class="relative"
      >
        @switch (item.operation) {
          @case ('export-pdf') {
            <nrc-pdf-export-progress [progress]="item" />
          }
          @case ('download') {
            <nrc-download-progress [progress]="item" />
          }
          @case ('translation') {
            <nrc-translation-progress [progress]="item" />
          }
          @default {
            <nrc-generic-progress [progress]="item" />
          }
        }

        <!-- Close button overlay -->
        <button
          type="button"
          (click)="removeItem(item.id)"
          class="absolute top-1 right-1 w-4 h-4 flex items-center justify-center rounded-full hover:bg-gray-600/50 transition-colors duration-200 flex-shrink-0 z-10"
          [attr.aria-label]="'Close notification'"
        >
          <nrc-icon
            [name]="'plus'"
            [classList]="['rotate-45']"
            class="w-3 h-3 text-gray-400 hover:text-gray-200"
          />
        </button>
      </div>
    }
  }
</div>
